import { createStyles, makeStyles, Theme } from '@material-ui/core';
import theme from '../../../../theme';

const UploadPanelStyles = makeStyles(({ palette }: Theme) => createStyles({
  recordingList: {
    maxHeight: 250,
    minHeight: 39,
    overflowY: 'auto',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: palette.studio.borderColor,
    borderRadius: 3,
    fontSize: 16,
    padding: '4px 8px',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Roboto',
  },

  recordingIcon: {
    width: 16,
    height: 16,
    border: '2px solid #fff',
    borderRadius: '100%',
    backgroundColor: theme.palette.studio.background,
    marginRight: 7,

    '& .circle': {
      height: 10,
      color: 'red',
    },
  },
  icon: {
    height: 16,
    width: 16,
    verticalAlign: 'middle',
    color: '#DCDEE5',

    '&.removeAbsoluteIcon': {
      position: 'absolute',
    },
  },

  successIcon: {
    color: '#00C0D4',
    position: 'absolute',
  },
  actionContainer: {
    marginLeft: 'auto',
  },
  removeMargin: {
    margin: '0px !important',
  },
  preview: {
    cursor: 'pointer',
    padding: 4,
    borderBottom: `1px solid ${palette.studio.borderColor}`,
  },
  action: {
    color: '#DCDEE5',
    padding: 0,
    marginLeft: 10,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)',
    },
  },
  headerAction: {
    padding: 0,
    marginLeft: 10,
  },
  errorIcon: {
    fontSize: 16,
    color: '#FF6C00',
    verticalAlign: 'middle',
  },
  titleContainer: {
    display: 'flex',
    maxWidth: 150,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  title: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  label: {
    fontSize: '12px',
    color: '#FFF',
    margin: 0,
    padding: '0 0 5px 0',
  },

  iconContainer: {
    position: 'relative',
    height: '16px',
    width: '16px',
  },

  uploadingContainer: {
    position: 'relative',
    '& span': {
      marginRight: '10px',
      fontSize: '0.625rem',
    },
  },


}), { name: 'CameraUploadPanel' });

export default UploadPanelStyles;
